// Materia-UI Icons

import MuiAddIcon from '@material-ui/icons/AddRounded';
import MuiAppsIcon from '@material-ui/icons/AppsRounded';
import MuiArrowBackIcon from '@material-ui/icons/ArrowBackRounded';
import MuiArrowDropDownIcon from '@material-ui/icons/ArrowDropDownRounded';
import MuiArrowDownIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import MuiArrowDownwardIcon from '@material-ui/icons/ArrowDownwardRounded';
import MuiArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeftRounded';
import MuiArrowRightIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import MuiArrowUpIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import MuiArrowUpwardIcon from '@material-ui/icons/ArrowUpwardRounded';
import MuiAttachFileIcon from '@material-ui/icons/AttachFileRounded';
import MuiAudioTrackIcon from '@material-ui/icons/AudiotrackRounded';
import MuiBlockIcon from '@material-ui/icons/BlockRounded';
import MuiCheckIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import MuiCloseIcon from '@material-ui/icons/CloseRounded';
import MuiCommentIcon from '@material-ui/icons/ChatBubbleRounded';
import MuiDateIcon from '@material-ui/icons/EventRounded';
import MuiDateCheckIcon from '@material-ui/icons/EventAvailableRounded';
import MuiDateRangeIcon from '@material-ui/icons/DateRange';
import MuiDeleteIcon from '@material-ui/icons/DeleteRounded';
import MuiEditIcon from '@material-ui/icons/EditRounded';
import MuiEmailIcon from '@material-ui/icons/EmailRounded';
import MuiErrorIcon from '@material-ui/icons/ErrorOutlineRounded';
import MuiExitToAppIcon from '@material-ui/icons/ExitToAppRounded';
import MuiFacebookIcon from '@material-ui/icons/Facebook';
import MuiFilterListIcon from '@material-ui/icons/FilterListRounded';
import MuiDescriptionIcon from '@material-ui/icons/DescriptionRounded';
import MuiGetAppIcon from '@material-ui/icons/GetAppRounded';
import MuiHelpIcon from '@material-ui/icons/HelpOutlineRounded';
import MuiHomeIcon from '@material-ui/icons/HomeRounded';
import MuiImportExportIcon from '@material-ui/icons/ImportExportRounded';
import MuiInfoIcon from '@material-ui/icons/InfoOutlined';
import MuiInstagramIcon from '@material-ui/icons/Instagram';
import MuiLinkedInIcon from '@material-ui/icons/LinkedIn';
import MuiLockIcon from '@material-ui/icons/LockRounded';
import MuiMenuIcon from '@material-ui/icons/MenuRounded';
import MuiMoreIcon from '@material-ui/icons/MoreRounded';
import MuiMoreHorizIcon from '@material-ui/icons/MoreHorizRounded';
import MuiMoreVertIcon from '@material-ui/icons/MoreVertRounded';
import MuiNotificationsIcon from '@material-ui/icons/NotificationsRounded';
import MuiPersonIcon from '@material-ui/icons/PersonRounded';
import MuiPhoneIcon from '@material-ui/icons/PhoneRounded';
import MuiRadioUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import MuiRemoveIcon from '@material-ui/icons/RemoveCircleOutlineRounded';
import MuiSearchIcon from '@material-ui/icons/SearchRounded';
import MuiSettingsIcon from '@material-ui/icons/SettingsRounded';
import MuiSortIcon from '@material-ui/icons/SortRounded';
import MuiTheatersIcon from '@material-ui/icons/TheatersRounded';
import MuiTimeIcon from '@material-ui/icons/AccessTimeRounded';
import MuiTranslateIcon from '@material-ui/icons/TranslateRounded';
import MuiTwitterIcon from '@material-ui/icons/Twitter';
import MuiVisibilityIcon from '@material-ui/icons/VisibilityRounded';
import MuiVisibilityOffIcon from '@material-ui/icons/VisibilityOffRounded';
import MuiWarnIcon from '@material-ui/icons/ReportProblemOutlined';
import MuiYouTubeIcon from '@material-ui/icons/YouTube';

// MDI
import MdiCircle from 'mdi-material-ui/Circle';
import MdiFileCSV from 'mdi-material-ui/FileDelimited';
import MdiFileExcel from 'mdi-material-ui/FileExcel';
import MdiFilePDF from 'mdi-material-ui/FilePdf';
import MdiFilePowerpoint from 'mdi-material-ui/FilePowerpoint';
import MdiFileWord from 'mdi-material-ui/FileWord';
import MdiLockQuestion from 'mdi-material-ui/LockQuestion';

export const Icons = {
  Add: MuiAddIcon,
  Apps: MuiAppsIcon,
  ArrowBack: MuiArrowBackIcon,
  ArrowDropDown: MuiArrowDropDownIcon,
  ArrowDown: MuiArrowDownIcon,
  ArrowDownward: MuiArrowDownwardIcon,
  ArrowLeft: MuiArrowLeftIcon,
  ArrowRight: MuiArrowRightIcon,
  ArrowUp: MuiArrowUpIcon,
  ArrowUpward: MuiArrowUpwardIcon,
  AttachFile: MuiAttachFileIcon,
  AudioTrack: MuiAudioTrackIcon,
  Block: MuiBlockIcon,
  Check: MuiCheckIcon,
  Close: MuiCloseIcon,
  Circle: MdiCircle,
  Comment: MuiCommentIcon,
  Date: MuiDateIcon,
  DateCheck: MuiDateCheckIcon,
  DateRange: MuiDateRangeIcon,
  Delete: MuiDeleteIcon,
  Edit: MuiEditIcon,
  Email: MuiEmailIcon,
  Error: MuiErrorIcon,
  ExitToApp: MuiExitToAppIcon,
  Facebook: MuiFacebookIcon,
  FilterList: MuiFilterListIcon,
  FileCSV: MdiFileCSV,
  FileDescription: MuiDescriptionIcon,
  FileExcel: MdiFileExcel,
  FilePDF: MdiFilePDF,
  FilePowerpoint: MdiFilePowerpoint,
  FileWord: MdiFileWord,
  GetApp: MuiGetAppIcon,
  Help: MuiHelpIcon,
  Home: MuiHomeIcon,
  Instagram: MuiInstagramIcon,
  ImportExport: MuiImportExportIcon,
  Info: MuiInfoIcon,
  LinkedIn: MuiLinkedInIcon,
  Lock: MuiLockIcon,
  LockQuestion: MdiLockQuestion,
  Menu: MuiMenuIcon,
  More: MuiMoreIcon,
  MoreHoriz: MuiMoreHorizIcon,
  MoreVert: MuiMoreVertIcon,
  Notifications: MuiNotificationsIcon,
  Person: MuiPersonIcon,
  Phone: MuiPhoneIcon,
  RadioUnchecked: MuiRadioUncheckedIcon,
  Remove: MuiRemoveIcon,
  Search: MuiSearchIcon,
  Settings: MuiSettingsIcon,
  Sort: MuiSortIcon,
  Theaters: MuiTheatersIcon,
  Time: MuiTimeIcon,
  Translate: MuiTranslateIcon,
  Twitter: MuiTwitterIcon,
  Visibility: MuiVisibilityIcon,
  VisibilityOff: MuiVisibilityOffIcon,
  Warn: MuiWarnIcon,
  YouTube: MuiYouTubeIcon,
};